export default __webpack_public_path__ + "static/logo-ea9efc3627f54592aeae5e5693ccadde.png";